import { UrlUtil } from '@shared/url-util';

const BASE_URL = window.environment.baseUrl;

export class Urls {
    public static readonly aboutPage = 'about';
    public static readonly appSelectPage = BASE_URL.toString();
    public static readonly logInPage = 'login';
    public static readonly logoutPage = UrlUtil.makeUrl(BASE_URL, 'logout', undefined);
    public static readonly logsPage = 'admin/logs';
    public static readonly mobileAppsPage = 'mobile-apps';
    public static readonly passwordResetPage = 'password-reset';
    public static readonly pluginManagementPage = 'admin/plugin-management';
    public static readonly privacyNoticeLink = 'https://www.trimble.com/en/our-commitment/responsible-business/data-privacy-and-security/data-privacy-center/privacy-notice';

    public static readonly tidMyProfileLinkProduction = 'https://myprofile.trimble.com';
    public static readonly tidMyProfileLinkStaging = 'https://stage.myprofile.trimblecloud.com';

    public static readonly unityMaintainAndroidNativeStoreLink = 'https://play.google.com/store/apps/details?id=com.trimble.unity.field';
    public static readonly unityMaintainIosNativeStoreLink = 'https://apps.apple.com/us/app/trimble-unity-field/id6596775266';
    public static readonly unityMaintainUwpLink = 'https://apps.microsoft.com/detail/9nprkzc4g6wz';

    public static getParamsAsObject(query: string) {

        query = query.substring(query.indexOf('?') + 1);

        const re = /([^&=]+)=?([^&]*)/g;
        const decodeRE = /\+/g;

        const decode = function(str: string) {
            return decodeURIComponent(str.replace(decodeRE, ' '));
        };

        const params: Record<string, string | string[]> = {};
        let e: RegExpExecArray | null;
        // eslint-disable-next-line no-cond-assign
        while (e = re.exec(query)) {
            let k = decode(e[1]);
            const v = decode(e[2]);
            if (k.substring(k.length - 2) === '[]') {
                k = k.substring(0, k.length - 2);
                ((params[k] || (params[k] = [])) as string[]).push(v);
            } else {
                params[k] = v;
            }
        }

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const assign = function(obj: any, keyPath: string[], value: string | string[]) {
            const lastKeyIndex = keyPath.length - 1;
            for (let i = 0; i < lastKeyIndex; ++i) {
                const key = keyPath[i];
                if (!(key in obj)) {
                    obj[key] = {};
                }
                obj = obj[key];
            }
            obj[keyPath[lastKeyIndex]] = value;
        };

        for (const prop in params) {
            const structure = prop.split('[');
            if (structure.length > 1) {
                const levels: string[] = [];
                structure.forEach(function(item) {
                    const key = item.replace(/[?[\]\\ ]/g, '');
                    levels.push(key);
                });
                assign(params, levels, params[prop]);
                delete (params[prop]);
            }
        }
        return params;
    }

    public static makeAppSelectionUrl(): URL {
        return UrlUtil.makeUrl(BASE_URL, '', undefined);
    }

    public static makePluginUrl(route: string, pluginRelativePath: string): URL {
        return UrlUtil.makeUrl(BASE_URL, UrlUtil.joinUrlParts(`apps/${route}`, pluginRelativePath), undefined);
    }

    public static makeRouteUrl(path: string, query: Record<string, string> | undefined): URL {
        return UrlUtil.makeUrl(BASE_URL, path, query);
    }

    /**
     * Set either option.lastApp (to open last app) or option.uid
     * (to open the app with the UID)
     * but do not set both.
     */
    public static makeSwitchAppUrl(option: { lastApp?: boolean; uid?: string }): URL {
        const params: Record<string, string> = {};
        if (option.lastApp) {
            params.last = 'true';
        }
        if (option.uid) {
            params.uid = option.uid;
        }
        return UrlUtil.makeUrl(BASE_URL, 'switch-app', params);
    }
}
